const COOKIE_NAME = 'SDMTemplateSearch';
const COOKIE_DURATION_DAYS = 30;

const setDisplayModeCookie = (value) => {
  const expires = new Date(Date.now() + COOKIE_DURATION_DAYS * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${COOKIE_NAME}=${value}; expires=${expires}; path=/`;
};

for (const button of document.querySelectorAll('.js-displayMode')) {
  button.addEventListener('click', () => {
    setDisplayModeCookie(button.dataset.display);
  });
}
